import merge from 'lodash/merge';
import { useContext, useMemo } from 'react';
import { flattenObject } from '@/utils/objects';
import { mergeThemeWithVariants } from '@/services/widgetTheme';
import { ThemeContext } from './useThemeProvider';
export const useThemeContext = () => {
  const context = useContext(ThemeContext);

  if (!context) {
    throw new Error('useThemeContext must be used within a <ThemeProvider />');
  }

  return context;
};
export const useTheme = () => {
  const themeCtx = useThemeContext();
  return useMemo(() => createPublicThemeValue(themeCtx), [themeCtx]);
};

const createPublicThemeValue = themeCtx => {
  const mergedTheme = mergeThemeWithVariants(themeCtx.theme, themeCtx.mode);
  return {
    theme: mergedTheme,
    mode: themeCtx.mode,
    colorPallet: themeCtx.colorPallet,
    colorPresets: themeCtx.colorPresets,
    colorPallets: themeCtx.colorPallets,
    baseColorPresets: themeCtx.baseColorPresets,
    handleChange: themeCtx.handleChange,
    handleReplace: themeCtx.handleReplace
  };
}; // Generates flattened style variables from theme


export const generateStyleVariables = function (theme) {
  var _theme$spacing, _theme$spacing2;

  let skipVariables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return merge({}, !skipVariables.includes('base') ? flattenObject(theme.base, '', '-', 'base') : {}, !skipVariables.includes('padding') ? flattenObject((_theme$spacing = theme.spacing) === null || _theme$spacing === void 0 ? void 0 : _theme$spacing.padding, 'padding', '-') : {}, !skipVariables.includes('radius') ? flattenObject((_theme$spacing2 = theme.spacing) === null || _theme$spacing2 === void 0 ? void 0 : _theme$spacing2.radius, '', '-') : {}, flattenObject(theme.color, 'color', '-'), flattenObject(theme.typography, '', '-'), flattenObject(theme.elements, '', '-'));
};